export const VIDEO_WATCH_ENGLISH_COPY = {
  learn: "What you will learn",
  focus: "Read transcript in focus mode",
  back: "Back to overview",
  jump: "Jump to {time}",
  video: "{title} video",
  details: "Video details",
  overview: "Overview",
  transcript: "Transcript",
};
export type VideoWatchCopy = typeof VIDEO_WATCH_ENGLISH_COPY;

export const VIDEO_WATCH_PAGE_ENGLISH_COPY = {
  "home": "Home",
  "videos": "Videos",
  "breadcrumb": "Breadcrumb",
  "notes": "{subject} Notes",
  "continue": "Continue {topic}",
  "nextDescription": "Keep the same topic and move to the explanation or a quick check.",
  "readNotes": "Read exact notes",
  "practise": "Practise this topic",
  "notesDescription": "Want the full notes on this topic? Open the {subject} notes hub for the chapter walkthrough, formulas, and worked examples.",
  "openNotes": "Open the {subject} notes hub →",
  "mediaDisclosure": "This Chinese transcript follows the original English video. Narration, captions and on-screen text remain in English; timestamps refer to the original video.",
  "continueTopic": "Continue this topic",
  "subjectMaths": "H2 Maths",
  "subjectPhysics": "H2 Physics",
  "subjectChemistry": "H2 Chemistry",
  "subjectBiology": "H2 Biology"
};
export type VideoWatchPageCopy = typeof VIDEO_WATCH_PAGE_ENGLISH_COPY;
